const truncateString = (string: string, length = 10) => {
  if (string.length > length) {
    return string.slice(0, length) + '...'
  }
  return string
}

export default truncateString
